// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import cartLineSharedStyles from "@steiner/App/SharedStyles/CartLineSharedStyles";
import { orderLinesListStyles } from "@steiner/Overrides/Components/OrderLinesList";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

orderLinesListStyles.productInfoQtyOrderedGridItem = {
    width: 12,
};

orderLinesListStyles.orderLineInfoGridItem = {
    width: 12,
};

orderLinesListStyles.productInfoQtyShippedGridItem = {
    width: 12,
};

orderLinesListStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};

orderLinesListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

orderLinesListStyles.productInfoSubtotalHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};

orderLinesListStyles.subtotalWithoutVatHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};

orderLinesListStyles.orderLineCardImage = {
    ...cartLineSharedStyles.productImage?.linkWrappingImage,
};

orderLinesListStyles.priceHeadingAndText = {
    text: {
        ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
            css: css`
                display: inline-flex;
                width: auto;
            `,
        }),
    },
};

orderLinesListStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

orderLinesListStyles.priceText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
        css: css`
            display: inline-flex;
            width: auto;
        `,
    }),
};

orderLinesListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.productPrice?.price?.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: ${fontConfig.lineHeight.xSmall};
            margin-left: 4px;
        `,
    }),
};

orderLinesListStyles.productBrandStyles = {
    nameLink: {
        css: css`
            @media print {
                display: block;
                width: 100%;
            }
        `,
    },
};

orderLinesListStyles.orderLineCardAddToListButton = {
    ...cartLineSharedStyles.cartLineNotes?.addToProjectsLink,
};

orderLinesListStyles.productInfoSubtotalHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};

orderLinesListStyles.productInfoQtyOrderedHeadingAndText = {
    text: {
        css: css`
            ${xScreen("lte", "md")} {
                text-align: left;
            }
        `,
    },
};

orderLinesListStyles.productInfoQtyShippedHeadingAndText = {
    text: {
        css: css`
            ${xScreen("lte", "md")} {
                text-align: left;
            }
        `,
    },
};

const commonPrintStyles = css`
    min-width: 12%;
    max-width: 12%;
    float: right;
    margin-top: 0;
`;

orderLinesListStyles.orderLineContainer = {
    container: {
        css: css`
            @media print {
                border-top: 0;
            }
        `,
    },
    image: {
        css: css`
            @media print {
                display: none;
            }
        `,
    },
    description: {
        css: css`
            @media print {
               &&& {
                width: 45%;
               float: left;
                min-width: 45%;
                max-width: 45%;
                margin: 0;

                ${TypographyStyle} {
                font-size: 12px;
                font-weight: 400;
                line-height: 16px;
                }
               }
            }
        `,
    },
    price: {
        css: css`
            @media print {
                ${commonPrintStyles}
            }
        `,
    },
    qty: {
        css: css`
            @media print {
                ${commonPrintStyles}
            }
        `,
    },
    qtyShipped: {
        css: css`
            @media print {
                ${commonPrintStyles}
            }
        `,
    },
    total: {
        css: css`
            @media print {
                ${commonPrintStyles}
            }
        `,
    },
};

orderLinesListStyles.qtyOrderedText = {
    css: css`
        display: none;
        font-size: 12px;
        font-weight: 400;

        ${xScreen("lte", "md")} {
            display: block;
        }
    `,
};

orderLinesListStyles.productInfoQtyOrderedGridItem =
    orderLinesListStyles.productInfoQtyShippedGridItem = {
        css: css`
        flex-wrap: wrap;

        ${TypographyStyle} {
            white-space: nowrap;
        }
    `,
}